import { BreadcrumbComponentType } from 'use-react-router-breadcrumbs';

const DynamicBaseCreateBreadcrumb: BreadcrumbComponentType = () => {
  return <span>Створити</span>;
};

const DynamicBaseEditBreadcrumb: BreadcrumbComponentType = () => {
  return <span>Редагувати</span>;
};

const DynamicBaseDossierBreadcrumb: BreadcrumbComponentType = () => {
  return <span>Досьє</span>;
};

export const DynamicBaseBreadcrumb = {
  DynamicBaseCreateBreadcrumb,
  DynamicBaseEditBreadcrumb,
  DynamicBaseDossierBreadcrumb
};
